import React, { useState, useEffect } from 'react';
import './EquipmentModal.css';

const industrialOptions = [
  // Systèmes de traitement d'air
  "Système de ventilation industrielle",
  "Unité de traitement d'air",
  "Climatiseur industriel",
  "Sécheur d'air",
  "Dépoussiéreur industriel",
  // Équipements de production d'énergie
  "Groupe électrogène",
  "Transformateur électrique",
  "Onduleur industriel",
  "Batterie stationnaire",
  "Tableau électrique industriel",
  // Équipements hydrauliques/pneumatiques
  "Pompe industrielle",
  "Compresseur industriel",
  "Système hydraulique",
  "Vanne industrielle",
  "Système de filtration",
  // Équipements chauffage/refroidissement
  "Chaudière industrielle",
  "Échangeur thermique",
  "Four industriel",
  "Système de refroidissement",
  "Tour de refroidissement",
  // Équipements de stockage/manutention
  "Silo industriel",
  "Convoyeur industriel",
  "Grue industrielle",
  "Chariot élévateur électrique",
  "Système de stockage automatisé",
  // Équipements de traitement des eaux
  "Station d'épuration",
  "Système de traitement des eaux usées",
  "Système d'osmose inverse",
  "Adoucisseur d'eau industriel",
  "Filtre à eau industriel",
  // Équipements de contrôle et automation
  "Automate programmable (PLC)",
  "Interface homme-machine (IHM)",
  "Système SCADA",
  "Capteur industriel",
  "Variateur de fréquence",
  "Armoire de commande",
  // Équipements de laboratoire/mesure
  "Spectromètre",
  "Chromatographe",
  "Système d'analyse en ligne",
  "Balance industrielle",
  "Machine de test de matériaux"
];

const ISOLEMENT_OPTIONS = ["1", "10", "M", "B", "<0,5", ">0,5", "100"];

export default function MaterielIndustrielModal({ isOpen, onClose, onSave, local, equipment }) {
  const [formData, setFormData] = useState({
    category: 'materiel_industriel',
    name: '',
    existing_quantity: 1,
    verified_quantity: 1,
    protection_type: 'D',
    ce_marking: 'Oui',
    continuity_result: 'Bon',
    isolement: '',
    result: 'conforme'
  });

  useEffect(() => {
    if (equipment) {
      setFormData(equipment);
    }
  }, [equipment]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.continuity_result) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }
    onSave({
      type: 'materiel_industriel',
      ...formData
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="equipment-modal-overlay" onClick={onClose}>
      <div className="equipment-modal" onClick={(e) => e.stopPropagation()}>
        <div className="equipment-modal-header">
          <div>
            <h2 className="equipment-modal-title">🏭 Matériel industriel</h2>
            <p className="equipment-modal-subtitle">{local?.nom}</p>
          </div>
          <button onClick={onClose} className="equipment-close-button">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="equipment-form">
          <div className="equipment-form-scroll">
            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Type de matériel industriel <span className="equipment-required">*</span>
              </label>
              <input
                type="text"
                list="industrial-options"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="equipment-form-input"
                placeholder="Sélectionnez ou saisissez un type de matériel"
                required
              />
              <datalist id="industrial-options">
                {industrialOptions.map(opt => <option key={opt} value={opt} />)}
              </datalist>
            </div>

            <div className="equipment-form-row">
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité existante</label>
                <input
                  type="number"
                  min="0"
                  value={formData.existing_quantity}
                  onChange={(e) => setFormData({...formData, existing_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                />
              </div>
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité vérifiée</label>
                <input
                  type="number"
                  min="0"
                  value={formData.verified_quantity}
                  onChange={(e) => setFormData({...formData, verified_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                />
              </div>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Type de protection</label>
              <input
                type="text"
                value={formData.protection_type}
                onChange={(e) => setFormData({...formData, protection_type: e.target.value})}
                className="equipment-form-input"
              />
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Marquage CE</label>
              <select
                value={formData.ce_marking}
                onChange={(e) => setFormData({...formData, ce_marking: e.target.value})}
                className="equipment-form-select"
              >
                <option value="Oui">Oui</option>
                <option value="Non">Non</option>
              </select>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Continuité PE <span className="equipment-required">*</span>
              </label>
              <select
                value={formData.continuity_result}
                onChange={(e) => setFormData(prev => ({
                  ...prev,
                  continuity_result: e.target.value,
                  isolement: e.target.value === 'Mauvais' ? '>0,5' : prev.isolement
                }))}
                className="equipment-form-select"
                required
              >
                <option value="">- Sélectionner -</option>
                <option value="Bon">Bon</option>
                <option value="Mauvais">Mauvais</option>
                <option value="Classe II">Classe II</option>
                <option value="Déconnecté">Déconnecté</option>
                <option value="NVE">NVE</option>
                <option value="NVI">NVI</option>
                <option value="NVX">NVX</option>
                <option value="SO-PI">SO-PI</option>
              </select>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Isolement (MΩ)</label>
              <input
                type="text"
                list="isolement-options-industriel"
                value={formData.isolement || ''}
                onChange={(e) => setFormData({...formData, isolement: e.target.value})}
                className="equipment-form-input"
                placeholder="Ex: >0,5, 1, 10, 100, M, B..."
              />
              <datalist id="isolement-options-industriel">
                {ISOLEMENT_OPTIONS.map(opt => <option key={opt} value={opt} />)}
              </datalist>
            </div>
          </div>

          <div className="equipment-form-buttons">
            <button type="button" onClick={onClose} className="equipment-cancel-button">
              ← Retour
            </button>
            <button type="submit" className="equipment-save-button">
              {equipment ? 'Mettre à jour' : '+ Ajouter rapidement'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}